import React from 'react';

export type AutoFrame = { x0: number; y0: number; x1: number; y1: number };

export const AutoFramesOverlay: React.FC<{
  frames: AutoFrame[];
  selected: Set<number>;
  onToggle: (idx: number, e: React.MouseEvent<HTMLDivElement>) => void;
  width: number;
  height: number;
}> = ({ frames, selected, onToggle, width, height }) => {
  return (
    <div
      data-autoframes-overlay
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        width,
        height,
        pointerEvents: 'auto',
        zIndex: 5,
      }}
    >
      {frames.map((r, i) => (
        <div
          key={i}
          data-autoframe
          style={{
            position: 'absolute',
            left: r.x0,
            top: r.y0,
            width: r.x1 - r.x0,
            height: r.y1 - r.y0,
            background: selected.has(i) ? 'rgba(82,196,26,0.18)' : 'rgba(255, 165, 0, 0.15)',
            border: selected.has(i) ? '2px solid #52c41a' : '1px dashed #fa8c16',
            boxSizing: 'border-box',
            cursor: 'pointer',
          }}
          title={`Auto frame ${i + 1}`}
          onMouseDown={(e)=>{ e.preventDefault(); e.stopPropagation(); }}
          onClick={(e)=>{ e.preventDefault(); e.stopPropagation(); onToggle(i, e); }}
        />
      ))}
    </div>
  );
};

export default AutoFramesOverlay;


